import type { TimelineItem } from "@/mocks/articles";

interface ArticleTimelineProps {
  items: TimelineItem[];
}

export default function ArticleTimeline({ items }: ArticleTimelineProps) {
  return (
    <ol className="relative mt-6 space-y-7 border-l border-background-300 pl-6">
      {items.map((item) => (
        <li key={`${item.date}-${item.title}`} className="relative">
          <span className="absolute -left-[31px] top-1 flex h-3.5 w-3.5 items-center justify-center rounded-full border-2 border-background-50 bg-primary-500" />
          <p className="label-caps font-heading text-xs font-bold text-primary-600">
            {item.date}
          </p>
          <h4 className="mt-1.5 font-heading text-base font-bold text-foreground-950">
            {item.title}
          </h4>
          <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.detail}</p>
        </li>
      ))}
    </ol>
  );
}